import {VerticalAlignment} from "../../../enums/verticalAlignment";
import DashboardElement from "~/models/dashboards/dashboardElement";
import Dashboard from "~/models/dashboards/dashboard";
import DashboardElementGridValidation from "~/models/navigableValidations/dashboardElementGridValidation";

export default class Grid extends DashboardElement {
  rootModel: Dashboard;
  layout_config: Array<number>;
  vertical_alignment: VerticalAlignment;

  constructor() {
    super();
    this.defineProperty("vertical_alignment", 1);
    this.defineProperty("layout_config", [1,1]);
    this.defineProperty("help_text", "");
  }

  _validation: DashboardElementGridValidation = new DashboardElementGridValidation(this);

  get isExpandable(){
    return true
  }
}